import { getEnvironment } from '../utils.mjs';

import { analyticsEventWhitelist } from './event-whitelist.js';

const { FF_WBRT_5465_HUB_REDUCE_ANALYTICS_EVENTS } = getEnvironment();
const reduceEvents = FF_WBRT_5465_HUB_REDUCE_ANALYTICS_EVENTS === 'true';

export const trackEvent = async (name, data) => {
  // Only send the event if it's the whitelist
  if (reduceEvents && !analyticsEventWhitelist.includes(name)) return;

  return analytics?.track?.(name, data);
};

export const trackPage = async (pageName) => {
  if (reduceEvents) return;

  return analytics?.page?.(pageName);
};

export const trackGroup = async (groupId, params) => {
  // We only use group for experiments so block all calls feature flag is ON
  if (reduceEvents) return;

  return analytics?.group?.(groupId, params);
};
